<template>
  <component
    v-bind:style="{ 'aspect-ratio': aspectRatio }"
    :is="to ? 'a' : 'div'"
    :href="to ? $router.resolve(to).href : null"
    :title="title"
    @click.prevent="to ? $router.push(to) : null"
  >
    <component :is="eager ? 'div' : VLazy">
      <template v-if="isVideo">
        <!-- In low-power mode on iOS, videos do not auto-play and have a big ugly play button. Safari can actually play back mp4 files inside an image tag, but in my experimentation, performance is not reliable. The best solution to maintain animation is to fallback to use an animated webp version as we do in the card library. Just leaving this commented code here for now. -->
        <!--
        <picture v-if="IS_IOS_SAFARI">
          <source
            type="video/mp4"
            :srcset="SIZES.map(([ key, w ]) => `${BASE_URL}/${id}/${key}.mp4 ${w}w`).join(', ')"
          />
          <img
            type="image/webp"
            :srcset="SIZES.map(([ key, w ]) => `${BASE_URL}/${id}/${key}.webp ${w}w`).join(', ')"
            :src="`${BASE_URL}/${id}/lg.webp`"
            :alt="alt"
            @load="$emit('loaded')"
          />
        </picture>
        -->
        <video
          playsinline autoplay muted loop
          :aria-label="alt"
          :poster="`${BASE_URL}/${id}/lg.webp`"
          @loadeddata="$emit('loaded')"
        >
          <!-- I'm not sure about the 'media' attribute -->
          <!--  :media="`(min-width: ${w}px)`" -->
          <source
            v-for="[ key, w ], i in SIZES"
            type="video/mp4"
            :src="`${BASE_URL}/${id}/${key}.mp4`"
            :media="(i == 2) ? null : `(max-width: ${w}px)`"
          />
          <img
            type="image/webp"
            :srcset="SIZES.map(([ key, w ]) => `${BASE_URL}/${id}/${key}.webp ${w}w`).join(', ')"
            :src="`${BASE_URL}/${id}/lg.webp`"
            :alt="alt"
            @load="$emit('loaded')"
          />
        </video>
      </template>
      <img
        v-else
        type="image/webp"
        :srcset="SIZES.map(([ key, w ]) => `${BASE_URL}/${id}/${key}.webp ${w}w`).join(', ')"
        :src="`${BASE_URL}/${id}/lg.webp`"
        :alt="alt"
        @load="$emit('loaded')"
      />
    </component>
  </component>
</template>


<style scoped>
img, video {
  display: block;
  width: 100%;
  max-width: 100%;
}

div, picture, img, video {
  border-radius: inherit;
}
</style>


<script>
import { VLazy } from 'vuetify/lib';
const BASE_URL = 'https://cdn.ellacard.com/media';
const SIZES = [ [ 'sm', 320 ], [ 'md', 640 ], [ 'lg', 1280 ] ];

export default {
  name: 'web-media',

  props: {
    aspectRatio: String,
    to: Object,
    title: String,
    id: String,
    alt: String,
    isVideo: Boolean,
    eager: Boolean
  },

  created() {
    Object.assign(this, { VLazy, BASE_URL, SIZES });
  }
}
</script>
